import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { loginActions } from "api/APIService";
import { useDispatch } from "react-redux";
import ApiService from "api/APIService";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  email: "",
  password: "",
};

export function ResetPage(props) {
  const dispatch = useDispatch();
  const location = useLocation();

  const [tokenInput, setTokenInput] = useState(false);

  const [loading, setLoading] = useState(false);
  const LoginSchema = Yup.object().shape({
    password: Yup.string()
      .min(7, "Minimum 7 symbols")
      .max(50, "Maximum 50 symbols")
      .required(),
    confirmPassword: Yup.string()
      .min(7, "Minimum 7 symbols")
      .max(50, "Maximum 50 symbols")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const getQueryParams = () => {
    const queryParams = new URLSearchParams(props.location.search);
    const params = {
      redirectPath: queryParams.get("redirectPath"),
    };
    return params;
  };

  const queryParams = new URLSearchParams(location.search);

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      setTimeout(() => {
        ApiService["resetUserPassword"]({
          userId: queryParams.get("userId"),
          passwordResetSecret: queryParams.get("passwordResetSecret"),
          password: values.password,
        })
          .then((result) => {
            disableLoading();
            setSubmitting(false);
            setStatus(result.message);
          })
          .catch((error) => {
            disableLoading();
            setSubmitting(false);
            setStatus(error.toString());
          });
      }, 1000);
    },
  });

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">Reset Password</h3>

        {/* <p className="text-muted font-weight-bold">
          Enter your <strong>UNISOT ID</strong> email and password
        </p> */}
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        {formik.status ? (
          <>
            {formik.status.startsWith("Error") ? (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            ) : (
              <div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="mb-10 alert alert-custom alert-dismissible">
            <div className="alert-text">Enter your new password</div>
          </div>
        )}

        <div className="form-group fv-plugins-icon-container">
          <input
            id="password"
            placeholder="Password"
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "password"
            )}`}
            name="password"
            {...formik.getFieldProps("password")}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container">
          <input
            id="confirmPassword"
            placeholder="Confirm Password"
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "password"
            )}`}
            name="confirmPassword"
            {...formik.getFieldProps("confirmPassword")}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        {/* {tokenInput && (
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Token"
              type="password"
              className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                "password"
              )}`}
              name="token"
              {...formik.getFieldProps("token")}
            />
            {formik.touched.token && formik.errors.token ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.token}</div>
              </div>
            ) : null}
          </div>
        )} */}
        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
          >
            <span>Reset</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
          <Link
            to="/auth/login"
            className="text-dark-50 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            Login
          </Link>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}
